var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScoreIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 10.3508L8.39012 13.592C8.61555 13.8077 8.71872 14.118 8.66522 14.4218L7.86569 19L12.0553 16.837C12.3333 16.6926 12.6667 16.6926 12.9447 16.837L17.1343 19L16.3348 14.4218C16.2822 14.118 16.3844 13.8077 16.6099 13.592L20 10.3508L15.3136 9.67854C15.0032 9.63354 14.7338 9.44227 14.5953 9.16568L12.5005 5L10.4047 9.16568C10.2662 9.44227 9.99777 9.63354 9.68637 9.67854L5 10.3508ZM18.3986 21.9997C18.2468 21.9997 18.0941 21.9634 17.9538 21.89L12.5005 19.0245L7.04529 21.89C6.72457 22.0597 6.33416 22.0311 6.03921 21.8175C5.74617 21.6039 5.59917 21.2425 5.66026 20.8849L6.70166 14.8193L2.28883 10.5254C2.02825 10.2717 1.9347 9.89316 2.04638 9.54796C2.15902 9.20277 2.45779 8.95103 2.81669 8.89858L8.91714 8.00795L11.6443 2.48775C11.9659 1.83742 13.0341 1.83742 13.3557 2.48775L16.0829 8.00795L22.1833 8.89858C22.5432 8.95103 22.8419 9.20277 22.9536 9.54796C23.0653 9.89316 22.9718 10.2717 22.7112 10.5254L18.2983 14.8193L19.3397 20.8849C19.4008 21.2425 19.2538 21.6039 18.9598 21.8175C18.7928 21.9386 18.5962 21.9997 18.3986 21.9997Z",
    fill: "#C6C6C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreIcon);
export default __webpack_public_path__ + "static/media/score-icon.24b0699f43fc76be1572e70865049f4d.svg";
export { ForwardRef as ReactComponent };